// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ok-1";
export var stateContainer = "_ok-0";